import { createFileRoute } from '@tanstack/react-router';
import { WizardStepRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';
import { ImportPreviewPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function ImportPreviewRoute() {
  return (
    <LastWorkspaceResolver>
      <WizardStepRouteView step="preview">
        <ImportPreviewPage />
      </WizardStepRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/$importId/setup/preview')({
  validateSearch: validateWizardSearch,
  component: ImportPreviewRoute,
});
